import React from 'react';
import List from 'shared/ui/List';
import MetaButton from 'shared/ui/MetaButton';
import ItemSelector from 'shared/ui/ItemSelector';

const formatDate = (date) => (date ? new Date(date).toLocaleDateString() : '—');
const formatPrice = (price) => Math.round(price || 0).toLocaleString('ru-RU');

const PositionsList = (props) => {
  const filterOptions = [
    {
      key: 'product',
      label: 'Товар',
      field: ({ value, onChange }) => (
        <ItemSelector
          targetUrl='/products/admin-api/products'
          onSelect={(item) => onChange([...value, item])}
          onRemove={(id) => onChange(value.filter((item) => item.id !== id))}
          selectedItems={value}
          placeholder='Выберите товар'
          searchPlaceholder='Поиск товара...'
          noItemsFoundText='Товары не найдены'
          isMultiSelect={true}
        />
      ),
      initialValue: props.product ? [props.product] : [],
    },
    {
      key: 'doc',
      label: 'Документ',
      field: ({ value, onChange }) => (
        <ItemSelector
          targetUrl='/docs/admin-api/docs'
          onSelect={(item) => onChange([...value, item])}
          onRemove={(id) => onChange(value.filter((item) => item.id !== id))}
          selectedItems={value}
          placeholder='Выберите документ'
          searchPlaceholder='Поиск документа...'
          noItemsFoundText='Документы не найдены'
          isMultiSelect={true}
        />
      ),
      initialValue: props.doc ? [props.doc] : [],
    },
    {
      key: 'from_store',
      label: 'Откуда',
      field: ({ value, onChange }) => (
        <ItemSelector
          targetUrl='/admin-api/stores'
          onSelect={(item) => onChange([...value, item])}
          onRemove={(id) => onChange(value.filter((item) => item.id !== id))}
          selectedItems={value}
          placeholder='Выберите магазин'
          searchPlaceholder='Поиск магазина...'
          noItemsFoundText='Магазины не найдены'
          isMultiSelect={true}
        />
      ),
      initialValue: props.from_store ? [props.from_store] : [],
    },
    {
      key: 'to_store',
      label: 'Куда (магазин)',
      field: ({ value, onChange }) => (
        <ItemSelector
          targetUrl='/admin-api/stores'
          onSelect={(item) => onChange([...value, item])}
          onRemove={(id) => onChange(value.filter((item) => item.id !== id))}
          selectedItems={value}
          placeholder='Выберите магазин'
          searchPlaceholder='Поиск магазина...'
          noItemsFoundText='Магазины не найдены'
          isMultiSelect={true}
        />
      ),
      initialValue: props.to_store ? [props.to_store] : [],
    },
    {
      key: 'client',
      label: 'Клиент',
      field: ({ value, onChange }) => (
        <ItemSelector
          targetUrl='/parties/admin-api/clients'
          onSelect={(item) => onChange([...value, item])}
          onRemove={(id) => onChange(value.filter((item) => item.id !== id))}
          selectedItems={value}
          placeholder='Выберите клиента'
          searchPlaceholder='Поиск клиента...'
          noItemsFoundText='Клиенты не найдены'
          isMultiSelect={true}
        />
      ),
      initialValue: props.to_client ? [props.to_client] : [],
    },
    {
      key: 'date__gte',
      label: 'Дата (с)',
      field: ({ value, onChange, className }) => (
        <input
          type='date'
          value={value}
          className={className}
          onChange={(e) => onChange(e.target.value)}
        />
      ),
      initialValue: '',
    },
    {
      key: 'date__lt',
      label: 'Дата (по)',
      field: ({ value, onChange, className }) => (
        <input
          type='date'
          value={value}
          className={className}
          onChange={(e) => onChange(e.target.value)}
        />
      ),
      initialValue: '',
    },
    {
      key: 'status',
      label: 'Статус',
      field: ({ value, onChange, className }) => (
        <select
          value={value}
          className={className}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value=''>Все</option>
          <option value='true'>Проведён</option>
          <option value='false'>Не проведён</option>
        </select>
      ),
      initialValue: '',
    },
  ];

  const columns = [
    { key: 'id', label: 'ID', hide: true },
    { 
      key: 'product', 
      label: 'Товар', 
      component: (item) => (
        <span className='text-blue-600'>{item.product?.meta?.name}</span>
      )
    },
    { 
      key: 'doc', 
      label: 'Документ', 
      component: (item) => MetaButton(item.doc),
      hide: true
    },
    { 
      key: 'quantity', 
      label: 'Кол-во',
      component: (item) => (
        <span className={item.quantity < 0 ? 'text-red-600' : ''}>
          {formatPrice(item.quantity)}
        </span>
      )
    },
    { 
      key: 'price', 
      label: 'Цена',
      component: (item) => <>{formatPrice(item.price)}</>
    },
    { 
      key: 'discount_sum', 
      label: 'Скидка',
      component: (item) => (
        <span className={item.discount_sum > 0 ? 'text-orange-600' : ''}>
          {formatPrice(item.discount_sum)}
        </span>
      ),
      hide: true
    },
    { 
      key: 'sum', 
      label: 'Сумма',
      component: (item) => (
        <span className={item.sum < 0 ? 'text-red-600' : 'text-green-600'}>
          {formatPrice(item.sum)}
        </span>
      )
    },
    { 
      key: 'purchase', 
      label: 'Закупка',
      component: (item) => <>{formatPrice(item.purchase)}</>,
      hide: true
    },
    { 
      key: 'profit', 
      label: 'Прибыль',
      component: (item) => (
        <span className={item.profit < 0 ? 'text-red-600' : 'text-green-600'}>
          {formatPrice(item.profit)}
        </span>
      )
    },
    { 
      key: 'date', 
      label: 'Дата', 
      component: (item) => <>{formatDate(item.date)}</> 
    },
    { 
      key: '_from', 
      label: 'Откуда', 
      component: (item) => MetaButton(item._from) 
    },
    { 
      key: '_to', 
      label: 'Куда', 
      component: (item) => MetaButton(item._to) 
    },
    { 
      key: 'status', 
      label: 'Статус',
      component: (item) => (
        <span className={`px-2 py-0.5 rounded text-xs ${item.status ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
          {item.status ? 'Проведён' : 'Нет'}
        </span>
      ),
      hide: true
    },
  ];

  return (
    <List
      targetUrl={props.targetUrl || '/docs/admin-api/positions'}
      filterOptions={filterOptions}
      columns={columns}
      filterString={props.filterString}
    />
  );
};

export default PositionsList;